module.exports = __webpack_public_path__ + "img/bg_make_02.73b63f58.png";